import React, { useMemo } from 'react';
import useTheme from '../../hooks/useTheme.js'

export default function ImageTheme ({ src, alt, ...props }) {
    const theme = useTheme();

    const themedSrc = useMemo(() => {
        return `/${theme}${src}`
    }, [theme, src])
    
    return (
        <img src={themedSrc} alt={alt} {...props} />
    )
}